export default function AccountCreateForm() {
    return {
        restrict: "E",
        scope: {},
        template: require("./template.html"),

        controller: ($scope, Users, ENV) => {
            $scope.debug = ENV.debug;

            /**
             * The following roles which is allowed for account creation on this site
             */

            const roles = [
                { id: 3, name: "Privatperson" },
                {
                    id: 4,
                    name: "Erhvervsdrivende aktør",
                },
                { id: 73, name: "Offentlig institution" },
                { id: 82, name: "Frivillig forening" },

                { id: 83, name: "Statsanerkendt fri- og privatskole" },
                { id: 72, name: "Københavns Kommune – intern" },
                { id: 15, name: "Folkeoplysende forening" },
            ];

            /**
             * wrap up all form models
             */
            const models = {
                role: roles[0], // default (Bruger)
                company: Users.CompanyModel(),
                user: Users.Model(),
            };

            /** $scope up */
            $scope.acCreateForm = {};
            $scope.roles = roles;
            $scope.models = angular.copy(models); // copy to ensure we can reset after submission

            $scope.displayForm = true;
            $scope.status = {
                error: null,
                success: null,
            };

            // $scope.$watchCollection(
            //     "acCreateForm.$error",
            //     function () {
            //         console.log("trig");
            //
            //     }
            //     //true
            // );

            const formValidationUI = () => {
                if (Object.keys($scope.acCreateForm.$error).length) {
                    const firstErrorKey = Object.keys(
                        $scope.acCreateForm.$error
                    )[0];

                    $scope.acCreateForm.$error[
                        firstErrorKey
                    ][0].$$element[0].focus();
                }
            };

            $scope.canCreate = () => {
                return (
                    $scope.models.role.name !=
                        "Statsanerkendt fri- og privatskole" &&
                    $scope.models.role.name != "Folkeoplysende forening"
                );
            };

            /**
             * API create user
             * @param {obj} user
             * @param {obj} role
             * @param {obj} company
             */
            $scope.createUser = (user, role, company) => {
                if (!$scope.acCreateForm.$valid) {
                    formValidationUI();

                    return false;
                }

                /**
                 * @since ApiV3
                 * username = email
                 * <input-email> directive has an availability check on both email and username -
                 * val email
                 * if username ( the email string ) !isAvailable - the entered email is not allowed
                 */

                // Email and username validation has allready been checked so just copy
                user.username = user.email; // username has validation  <input-email>

                /**
                 * Set role on user
                 */
                user.primaryRole = role.id;

                /**
                 * isActive
                 * admins have a possibility to disable a user
                 */
                user.isActive = true; // TO DO ::: LOW ::: no reason to set this in app - should be nullable and then set as true in API

                /**
                 * Prevent if form is not valid
                 */

                /**
                 * API create user
                 * skip models.role object
                 * note: The primaryRole has been set on the user, and the API payload doesnt want it
                 */
                Users.create(user, company).then(
                    () => {
                        //const createdUser = res;

                        resetFormAfterSubmission();

                        $scope.displayForm = false;
                        $scope.status.error = false;
                        $scope.status.success = true;
                    },
                    () => {
                        $scope.displayForm = false;
                        $scope.status.error = true;
                        $scope.status.success = false;
                    }
                );
            };

            const resetFormAfterSubmission = () => {
                $scope.acCreateForm.$setPristine();
                // Since Angular 1.3, set back to untouched state.
                $scope.acCreateForm.$setUntouched();

                $scope.models = angular.copy(models);
            };
        },
    };
}
